
import { Options, Vue } from "vue-class-component";
@Options({
  emits: ["click"]
})
export default class GoogleLoginButton extends Vue {
  click() {
    this.$emit("click");
  }
}
